import React from 'react';
import PropTypes from 'prop-types';

import Navigation from 'components/Navigation';
import navItems from './navItems.json';

const OwnerNavigation = ({ selectedKey }) => (
  <Navigation
    subtitle={'owner'}
    items={navItems}
    backTo={'/'}
    selectedKey={selectedKey}
    showHeader
  />
);

OwnerNavigation.propTypes = {
  selectedKey: PropTypes.string,
};

export default OwnerNavigation;
